
import DropTable from '@/components/neue/DropTable.vue'

export default {
  components: {
    DropTable
  }
}
